// Liquid rewrites button text after address changes. Keep the standard CTA label
// markup in sync without changing the plugin's click handlers or busy indicator.
export default function initLiquidCommerceButtons() {
	if (!['en-us', 'es-us'].includes(document.documentElement.lang.toLowerCase())) return;
	const selector = '.pr-usa-lc-product > .pr-usa-lc-product__trigger';
	const update = (button) => {
		if (button.classList.contains('pr-usa-lc-btn--busy')) return;
		const text = button.textContent.trim();
		const label = button.querySelector('.cmpl-cta-span');
		if (label && label.dataset.text === text) return;
		const span = document.createElement('span');
		span.className = 'cmpl-cta-span';
		span.dataset.text = text;
		span.textContent = text;
		button.replaceChildren(span);
	};
	const scan = (node) => {
		if (!(node instanceof Element)) return;
		const button = node.closest(selector);
		if (button) update(button);
		node.querySelectorAll(selector).forEach(update);
	};
	scan(document.body);
	new MutationObserver((records) => {
		records.forEach((record) => {
			scan(record.target instanceof Element ? record.target : record.target.parentElement);
			record.addedNodes.forEach(scan);
		});
	}).observe(document.body, { childList: true, characterData: true, subtree: true });
}
